export const DEFAULT_CONFIG = {
  municipality: "Hjørring",
  yearBefore: 2021,
  yearAfter: new Date().getFullYear(),
  monthFrom: "April",
  monthTo: "August",
  chartType: "percentage",
  valueTypeMonthly: "averageHourlyProportionConsumption",
  valueTypeByHour: "averageHourlyTotalConsumption",
};
